// @flow
import React, { type StatelessFunctionalComponent } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import configureStore from "./store";
import TableActions, { type TableActionsProps } from "../../containers/TablesActions";
import List from "../../components/MessageGroupsList";
import Notification from "../../components/Notification";
import { MESSAGE_GROUPS_LIST_TABLE } from "../../helpers/constants";
import { changeIsActiveSaga, deleteSaga } from "../../actions/tableActions";

const actionsProps: TableActionsProps<typeof MESSAGE_GROUPS_LIST_TABLE> = {
  tableKey: MESSAGE_GROUPS_LIST_TABLE,
  editPath: "/messageGroups/edit/:id",
  viewPath: "/messageGroups/view/:id",
  clonePath: "/messageGroups/clone/:id",
  disableDelete: false,
  onDelete: deleteSaga,
  onChangeIsActive: changeIsActiveSaga,
};

const MessageGroupsList: StatelessFunctionalComponent<{}> = () => (
  <DocumentTitle title="Message Groups">
    <Provider store={configureStore()}>
      <List TableActions={<TableActions {...actionsProps} />} />
      <Notification />
    </Provider>
  </DocumentTitle>
);

export default MessageGroupsList;
